import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
  PiBellRinging,
  PiPawPrint,
  PiShieldCheck,
  PiUsersThree,
} from 'react-icons/pi';
import Section, { Grid, Item, SectionHeading } from './whyYouChoose.style';

const featureIcons = {
  bell: PiBellRinging,
  community: PiUsersThree,
  paw: PiPawPrint,
  shield: PiShieldCheck,
};

const WhyYouChoose = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        whyChooseUs {
          iconName
          id
          text
          title
        }
      }
    }
  `);
  const { appJson: whyChooseUs } = data;

  return (
    <Section id="about" {...props}>
      <Container width="1400px">
        <SectionHeading>
          <Heading content="Why pet parents choose Furbuz" />
        </SectionHeading>
        <Grid>
          {whyChooseUs?.whyChooseUs?.map((feature) => {
            const FeatureIcon = featureIcons[feature?.iconName] || PiPawPrint;
            return (
              <Item key={feature?.id}>
                <figure aria-hidden="true">
                  <FeatureIcon />
                </figure>
                <Heading as="h3" content={feature?.title} />
                <Text content={feature?.text} />
              </Item>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
};

export default WhyYouChoose;
